
import React from "react";
import CustomerWrapper from '../../components/CustomerWrapper'

export default (props) => {
  return (
    <CustomerWrapper {...props}></CustomerWrapper>
  );
}